<template>
    <CompassTableBody>
        <CompassTableRow
            v-for="(_, index) in 6"
            :key="`objectives-listing-table__table-loader-${index}`"
            class="objectives-listing-table__table--loading"
        >
            <CompassTableBodyCell
                v-for="column in columns"
                :key="`objectives-listing-table__table-loader-${index}-column-${column.code}`"
                :minWidth="column.width"
            >
                <CompassSkeleton />
            </CompassTableBodyCell>
            <CompassTableBodyCell minWidth="48px">
                <CompassSkeleton />
            </CompassTableBodyCell>
        </CompassTableRow>
    </CompassTableBody>
</template>

<script>
export default {
    props: {
        columns: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.objectives-listing-table__table--loading {
    .compass-skeleton {
        width: 100%;
    }
}
</style>
